/**
 * getFormattedPositionInLine returns a diner's position in line
 * based on the current waitCount as an ordinal number
 *
 * In general, if there is 1 party on the waitlist, then your party
 * would be the "2nd" in line. Your position in line would then be
 * waitCount + 1.
 *
 * Then based on the last one or two digits, we assign a particular suffix.
 */
export function getFormattedPositionInLine(waitCount: number): string {
  const positionInLine = waitCount + 1;
  const positionInLineAsStr = positionInLine.toString();

  let isPositionInTeens = false;
  if (positionInLineAsStr.length >= 2) {
    const lastTwoDigits = parseInt(
      positionInLineAsStr.slice(positionInLineAsStr.length - 2)
    );
    isPositionInTeens = 11 <= lastTwoDigits && lastTwoDigits <= 19;
  }

  if (positionInLine === 1) {
    return 'next';
  }

  if (positionInLine % 10 === 1 && !isPositionInTeens) {
    return `${positionInLine}st`;
  }

  if (positionInLine % 10 === 2 && !isPositionInTeens) {
    return `${positionInLine}nd`;
  }

  if (positionInLine % 10 === 3 && !isPositionInTeens) {
    return `${positionInLine}rd`;
  }

  return `${positionInLine}th`;
}
